import { call, getContext, put, takeEvery } from "redux-saga/effects";

import {
  getCountersSuccess,
  getCountersFailure,
  getDistributionsSuccess,
  getDistributionsFailure,
  getSalesSuccess,
  getSalesFailure,
  getIncomeFailure,
  getIncomeSuccess,
  getTransactionsSuccess,
  getTransactionsFailure,
} from "./actions";
import {
  csvLinkReceivedActionTypes,
  downloadCsvActionTypes,
  getCountersActionTypes,
  getDistributionsActionTypes,
  getIncomeActionTypes,
  getSalesActionTypes,
  getTransactionsActionTypes,
} from "./actionTypes";
import { CONTEXT } from "@const/redux";

const getCountersAsync = ({ StatisticsService }) => {
  if (!StatisticsService) {
    console.log("Required services does not exist");

    return null;
  }

  return StatisticsService.getCounterStats();
};

function* getCounters() {
  try {
    const { StatisticsService } = yield getContext(CONTEXT.SERVICES);
    const { data } = yield call(getCountersAsync, { StatisticsService });

    yield put(getCountersSuccess(data));
  } catch ({ error }) {
    yield put(getCountersFailure(error));
  }
}

const getDistributionsAsync = ({ StatisticsService, startDate, endDate }) => {
  if (!StatisticsService) {
    console.log("Required services does not exist");

    return null;
  }

  return StatisticsService.getDistributions({ startDate, endDate });
};

function* getDistributions({ payload }) {
  try {
    const { startDate, endDate } = payload;
    const { StatisticsService } = yield getContext(CONTEXT.SERVICES);
    const { data } = yield call(getDistributionsAsync, {
      StatisticsService,
      startDate,
      endDate,
    });

    yield put(getDistributionsSuccess(data));
  } catch ({ error }) {
    yield put(getDistributionsFailure(error));
  }
}

const getSalesAsync = ({
  StatisticsService,
  startDate,
  endDate,
  priceType,
}) => {
  if (!StatisticsService) {
    console.log("Required services does not exist");

    return null;
  }

  return StatisticsService.getSalesStats({ startDate, endDate, priceType });
};

function* getSales({ payload }) {
  try {
    const { startDate, endDate, priceType } = payload;
    const { StatisticsService } = yield getContext(CONTEXT.SERVICES);
    const { data } = yield call(getSalesAsync, {
      StatisticsService,
      startDate,
      endDate,
      priceType,
    });

    yield put(getSalesSuccess(data));
  } catch ({ error }) {
    yield put(getSalesFailure(error));
  }
}

const getIncomeAsync = ({
  StatisticsService,
  startDate,
  endDate,
  priceType,
}) => {
  if (!StatisticsService) {
    console.log("Required services does not exist");

    return null;
  }

  return StatisticsService.getIncomeStats({ startDate, endDate, priceType });
};

function* getIncome({ payload }) {
  try {
    const { startDate, endDate, priceType } = payload;
    const { StatisticsService } = yield getContext(CONTEXT.SERVICES);
    const { data } = yield call(getIncomeAsync, {
      StatisticsService,
      startDate,
      endDate,
      priceType,
    });

    yield put(getIncomeSuccess(data));
  } catch ({ error }) {
    yield put(getIncomeFailure(error));
  }
}

const getTransactionsAsync = ({ StatisticsService, startDate, endDate }) => {
  if (!StatisticsService) {
    console.log("Required services does not exist");

    return null;
  }

  return StatisticsService.getTxStats({ startDate, endDate });
};

function* getTransactions({ payload }) {
  try {
    const { startDate, endDate } = payload;
    const { StatisticsService } = yield getContext(CONTEXT.SERVICES);

    const { data } = yield call(getTransactionsAsync, {
      StatisticsService,
      startDate,
      endDate,
    });

    yield put(getTransactionsSuccess(data));
  } catch ({ error }) {
    yield put(getTransactionsFailure(error));
  }
}

const requestCsvDownloadAsync = ({ StatisticsService, startDate, endDate }) => {
  if (!StatisticsService) {
    console.log("Required service does not exist");
    return;
  }

  return StatisticsService.downloadCsv({ startDate, endDate });
};

function* requestCsvDownload({ payload }) {
  const { StatisticsService, ToasterService } = yield getContext(
    CONTEXT.SERVICES,
  );

  try {
    yield call(requestCsvDownloadAsync, {
      StatisticsService,
      ...payload,
    });
    ToasterService.info("The file will start downloading soon.");
  } catch (error) {
    if (JSON.parse(error)?.error?.message) {
      ToasterService.error(JSON.parse(error)?.error?.message);
    }
  }
}

export const downloadFile = async ({ FilesService, link }) => {
  const res = await FilesService.getFile(link);
  const filename = link.split("/").at(-1);
  const blob = res.data;

  FilesService.downloadFile(blob, filename);
};

function* csvLinkReceived({ payload }) {
  try {
    const {
      data: { link },
    } = payload;

    const { FilesService } = yield getContext(CONTEXT.SERVICES);

    yield call(downloadFile, { FilesService, link });
  } catch (error) {
    console.log(error);
  }
}

export function* watchGetCounters() {
  yield takeEvery(getCountersActionTypes.request, getCounters);
}

export function* watchGetDistributions() {
  yield takeEvery(getDistributionsActionTypes.request, getDistributions);
}

export function* watchGetSales() {
  yield takeEvery(getSalesActionTypes.request, getSales);
}

export function* watchGetIncome() {
  yield takeEvery(getIncomeActionTypes.request, getIncome);
}

export function* watchGetTransactions() {
  yield takeEvery(getTransactionsActionTypes.request, getTransactions);
}

export function* watchRequestDownloadCsv() {
  yield takeEvery(downloadCsvActionTypes.request, requestCsvDownload);
}

export function* watchCsvLinkReceived() {
  yield takeEvery(csvLinkReceivedActionTypes.request, csvLinkReceived);
}
